import {Box, Stack} from '@dropbox/dig-foundations';
import type {ReactNode} from 'react';

import {Title} from './Title';

export type CommentThreadSection<T extends {id: string}> = {
  id: string;
  title?: ReactNode;
  threads: T[];
  muted?: boolean;
  renderThread: (thread: T) => ReactNode;
};

export const CommentThreadSections = <T extends {id: string}>({
  sections,
}: {
  sections: CommentThreadSection<T>[];
}) => {
  const visibleSections = sections.filter((section) => section.threads.length > 0);

  return (
    <Stack gap="16">
      {visibleSections.map((section, index) => (
        <Box key={section.id}>
          {section.title ? (
            <Box paddingTop={index === 0 ? undefined : '16'} paddingBottom="8">
              <Title size={16}>{section.title}</Title>
            </Box>
          ) : null}
          <Stack gap="16" style={section.muted ? {opacity: 0.5} : undefined}>
            {section.threads.map((thread) => section.renderThread(thread))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};
